import { render, staticRenderFns } from "./DialogConfirmChange.vue?vue&type=template&id=28c8d0ca&"
import script from "./DialogConfirmChange.vue?vue&type=script&lang=js&"
export * from "./DialogConfirmChange.vue?vue&type=script&lang=js&"
import style0 from "./DialogConfirmChange.vue?vue&type=style&index=0&id=28c8d0ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports